/**
 * GoBox Navigation - JavaScript Functionality
 * Handles sticky navigation scroll effect and mobile menu
 */

(function() {
  'use strict';

  function init() {
    setupScrollEffect();
    setupMobileMenu();
    setupScrollToButtons();
  }

  /**
   * Sticky navigation scroll effect
   */
  function setupScrollEffect() {
    const navs = document.querySelectorAll('.gobox-nav');
    if (navs.length === 0) return;

    function handleScroll() {
      const isScrolled = window.scrollY > 20;
      navs.forEach(nav => {
        nav.classList.toggle('scrolled', isScrolled);
      });
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial check
  }

  /**
   * Mobile menu toggle
   */
  function setupMobileMenu() {
    const menuButtons = document.querySelectorAll('.mobile-menu-btn');
    
    menuButtons.forEach(button => {
      button.addEventListener('click', function() {
        const nav = this.closest('.gobox-nav');
        const mobileMenu = nav.querySelector('.mobile-menu');
        
        if (mobileMenu) {
          mobileMenu.classList.toggle('active');
          mobileMenu.classList.toggle('hidden');
          
          // Toggle button icon (optional enhancement)
          const icon = this.querySelector('svg');
          if (mobileMenu.classList.contains('active')) {
            this.setAttribute('aria-expanded', 'true');
          } else {
            this.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });

    // Close mobile menu when clicking outside
    document.addEventListener('click', function(e) {
      const nav = e.target.closest('.gobox-nav');
      if (!nav) {
        document.querySelectorAll('.mobile-menu.active').forEach(menu => {
          menu.classList.remove('active');
          menu.classList.add('hidden');
        });
      }
    });
  }

  /**
   * Smooth scroll to section functionality
   */
  function setupScrollToButtons() {
    const scrollButtons = document.querySelectorAll('.scroll-to-reserve');
    
    scrollButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetId = this.dataset.scrollTarget || 'reserve-vip-ticket-section';
        const targetSection = document.getElementById(targetId);
        
        if (targetSection) {
          // Close mobile menu if open
          const mobileMenu = this.closest('.mobile-menu');
          if (mobileMenu) {
            mobileMenu.classList.remove('active');
            mobileMenu.classList.add('hidden');
          }
          
          // Smooth scroll to section
          const navHeight = 80; // Height of sticky nav
          const elementPosition = targetSection.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - navHeight;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
